import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white py-8 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Logo CCA */}
          <div className="flex items-center mb-4 md:mb-0">
            <img 
              src="images/cca-logo.svg" 
              alt="Logo CCA" 
              className="h-12 w-auto mr-4"
              onError={(e) => {
                // Fallback si l'image n'est pas trouvée
                e.currentTarget.style.display = 'none';
                const nextElement = e.currentTarget.nextElementSibling;
                if (nextElement && 'style' in nextElement) {
                  (nextElement as HTMLElement).style.display = 'flex';
                }
              }}
            />
            <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mr-4" style={{display: 'none'}}>
              <img 
                src="images/cca-logo.svg" 
                alt="CCA Logo" 
                className="h-8 w-auto"
              />
            </div>
            <div>
              <h3 className="text-lg font-bold">Le Conseil du Coton et de l'Anacarde</h3>
              <p className="text-sm text-gray-300">Organisation de régulation</p>
            </div>
          </div>

          {/* Informations de contact */}
          <div className="text-center md:text-right">
            <p className="text-sm text-gray-300 mb-2">
              © {new Date().getFullYear()} Conseil du Coton et de l'Anacarde
            </p>
            <p className="text-xs text-gray-400">
              Plateforme de Gestion des Pesées - Tous droits réservés
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
